import { render, staticRenderFns } from "./InsuranceCompanyPlanCrud.vue?vue&type=template&id=eab6c344&scoped=true&"
import script from "./InsuranceCompanyPlanCrud.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyPlanCrud.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceCompanyPlanCrud.vue?vue&type=style&index=0&id=eab6c344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab6c344",
  null
  
)

export default component.exports